import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=824934c6&scoped=true&"
import script from "./PostEdit.vue?vue&type=script&lang=js&"
export * from "./PostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824934c6",
  null
  
)

export default component.exports